export class Sobre {
    Texto: string;
    Arquivos?: string[];
}